const HIDE_ANIMATION_TIMEOUT = 500 // in milliseconds
const REMOVE_TIMEOUT = 5000 // in milliseconds
const SHOW_ANIMATION_TIMEOUT = 25 // in milliseconds
// Be careful lowering this timeout, too low and develops inconsistency whether sr will read or not
const SCREEN_READER_TIMEOUT = 500

// An open modal <dialog> covers everything in <body> and makes it inert, so a flash
// shown while one is open goes inside it, with an announcer of its own.
const openDialog = () => Array.from(document.querySelectorAll("dialog[open]")).pop()

const dialogAnnouncer = (dialog) => {
  let announcer = dialog.querySelector(":scope > [data-flash-announcer]")

  if (!announcer) {
    announcer = document.createElement("span")
    announcer.dataset.flashAnnouncer = ""
    announcer.setAttribute("role", "alert")
    announcer.setAttribute("aria-live", "assertive")
    announcer.setAttribute("aria-atomic", "true")
    announcer.className = "sr-only"
    dialog.appendChild(announcer)
  }

  return announcer
}

class FlashObject {
  static parse(node) {
    if (node.classList.contains("initialized")) return

    const flash = new FlashObject({})
    flash.body = node
    flash.body.addEventListener("click", () => flash.remove())
    flash.startRemoveTimeout()
    flash.announceToScreenReader(node.textContent)
    node.classList.add("initialized")
  }

  constructor(attrs) {
    const options = Object.assign(
      {
        type: "notice",
      },
      attrs,
    )

    this.body = document.createElement("p")
    this.body.classList.add("flash", "fold-to-top", options.type)
    this.body.textContent = options.message
    this.body.setAttribute("aria-hidden", "true")
    this.body.addEventListener("click", () => this.remove())
  }

  show() {
    const dialog = openDialog()
    const container = dialog ?? document.body
    container.appendChild(this.body)

    setTimeout(() => {
      this.body.classList.add("show")
      this.body.classList.remove("fold-to-top")
    }, SHOW_ANIMATION_TIMEOUT)

    this.startRemoveTimeout()
    this.announceToScreenReader(
      this.body.textContent,
      dialog ? () => dialogAnnouncer(dialog) : undefined,
    )
  }

  announceToScreenReader(
    message,
    findAnnouncer = () => document.getElementById("flash-announcer"),
  ) {
    const announcer = findAnnouncer()

    if (announcer && message) {
      announcer.textContent = ""

      setTimeout(() => {
        const currentAnnouncer = findAnnouncer()
        if (currentAnnouncer) {
          currentAnnouncer.textContent = message
        }
      }, SCREEN_READER_TIMEOUT)
    }
  }

  startRemoveTimeout() {
    setTimeout(this.remove.bind(this), REMOVE_TIMEOUT)
  }

  remove() {
    this.body.classList.remove("show")
    this.body.classList.add("fold-to-top")

    setTimeout(() => this.body.remove(), HIDE_ANIMATION_TIMEOUT)
  }
}

class Flash {
  static bindServerFlash() {
    Array.from(document.querySelectorAll("p.flash")).forEach((node) => FlashObject.parse(node))
  }

  static now(type, message) {
    new FlashObject({ type, message }).show()
  }
}

export default Flash
